<template>
    <app-table
        deletable
        :data="items"
        :highlight-rows-on-hover="true"
        @deleteRow="deleteItem"
        v-if="packages && packages.length > 0"
    >
        <template slot="secondary_header" v-if="isNewPackageAddAllowed">
            <div class="status search" style="min-height: 1px !important;" />
            <form class="filter expand_content open" @submit.prevent="submitForm">
                <div class="field_left">
                    <app-table-header-select :label="$gettext('Balíček')">
                        <app-select
                            id="newIdPackage"
                            :options="packageOptions"
                            selectId="newIdPackage"
                            name="idPackage"
                            v-model="newIdPackage"
                        />
                    </app-table-header-select>
                </div>

                <div class="field_right">
                    <app-content-save-button />
                </div>
            </form>
        </template>

        <app-table-column first :label="$gettext('Balíček')">
            <template slot-scope="row">
                {{ packagesById[row._id].name }}
            </template>
        </app-table-column>
        <app-table-column :label="$gettext('Provider')">
            <template slot-scope="row">
                {{ packagesById[row._id]._providerName }}
            </template>
        </app-table-column>
        <app-table-column :label="$gettext('Typ balíčku')">
            <template slot-scope="row">
                {{ packagesById[row._id].type }}
            </template>
        </app-table-column>
    </app-table>
</template>

<script>

export default {
    name: "packages",
    props: ['packages', 'assignedPackages'],
    emits: ['packagesChanged'],
    data() {
        return {
            newIdPackage: null,
            items: this.prepareItems(this.assignedPackages),
        }
    },
    methods: {
        prepareItems(items) {
            let packageIds = [];

            items.forEach((item) => {
                packageIds.push({ _id: item })
            })

            return packageIds;
        },
        deleteItem(itemToDelete) {
            this.items = this.items.filter((item) => item !== itemToDelete);

            this.packagesChanged();
        },
        submitForm(evt) {
            if (!this.newIdPackage) {
                return false;
            }

            if (!this.items) {
                this.items = [{_id: this.newIdPackage}];
            } else {
                this.items.push({_id: this.newIdPackage});
            }

            this.newIdPackage = null;

            this.packagesChanged();
        },
        packagesChanged() {
            const packageIds = [];
            this.items.forEach((item) => {
                packageIds.push(item._id);
            });

            this.$emit('packagesChanged', packageIds);
        }
    },
    computed: {
        availablePackages() {
            const filteredPackages = [];

            this.packages.forEach((providerPackage) => {
                if (this.items.findIndex((item) => {
                    return item._id === providerPackage._id;
                }) < 0) {
                    filteredPackages.push(providerPackage);
                }
            });

            return filteredPackages;
        },
        isNewPackageAddAllowed() {
            return this.availablePackages.length > 0;
        },
        packageOptions() {
            const values = [];

            this.availablePackages.forEach((availablePackage) => {
                values.push({
                    name: availablePackage.name + " (" + availablePackage.type + ") ",
                    value: availablePackage._id
                })
            })

            return values;
        },
        packagesById() {
            const packages = {};

            this.packages.forEach((item) => {
                packages[item._id] = item;
            })

            return packages;
        }
    }
}
</script>

